import styled from 'styled-components';
import ButtonLink from '../shared/ButtonLinkComponent';
import ImgWrapper from '../shared/ImgWrapper';
import ResponsiveVideoWrapper from '../shared/ResponsiveVideoWrapper';
import ServerStylesConditionalWrapper from '../shared/ServerStylesConditionalWrapper';
import { device } from '../../utils/styled-component-mixins';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';

const ImageWithTextStyled = styled.div`
  ${(props) =>
    props.backgroundImage &&
    `background: url("${props.backgroundImage}") 100% 100%/cover no-repeat;`}
  padding: 4rem 0;

  @media ${device.desktop} {
    padding: 8rem 0;
  }

  h2 {
    ${(props) => props.lightDarkTheme === 'dark' && `color: var(--white);`}
    margin-bottom: 2.4rem;
  }

  .img-wrapper,
  .video-wrapper {
    margin-bottom: 2.4rem;

    @media ${device.desktop} {
      margin-bottom: 0;
    }
  }

  .image-text-content {
    ${(props) => props.lightDarkTheme === 'dark' && `color: var(--white);`}
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 1.5rem;
  }

  .image-text-wrapper {
    > div:first-child {
      filter: drop-shadow(0px 16px 80px rgba(91, 110, 127, 0.25));
    }
    @media ${device.desktop} {
      ${(props) => props.imageSide === 'right' && `flex-direction: row-reverse;`}
      align-items: center;
      display: flex;
      column-gap: 13rem;

      > * {
        flex: 1 1 50%;
      }
    }
  }
`;

const ImageWithTextDescriptionStyled = styled.div`
  margin-bottom: 2.4rem;
`;

const ImageWithTextComponent = (props) => {
  const {
    backgroundImage,
    buttonText,
    buttonUrl,
    buttonType,
    icon,
    description,
    image,
    imageAltText,
    imageOrEmbed,
    imageSide,
    embedCode,
    lightDarkTheme,
    title
  } = props;

  return (
    <WidgetIdWrapper widgetID={props.widgetID}>
      <ServerStylesConditionalWrapper>
        <ImageWithTextStyled
          backgroundImage={backgroundImage}
          lightDarkTheme={lightDarkTheme.toLowerCase()}
          imageSide={imageSide.toLowerCase()}
        >
          <div className="container-padding-md image-text-wrapper">
            {imageOrEmbed === 'image' ? (
              <ImgWrapper imageSrc={image} imageAlt={imageAltText} />
            ) : (
              <ResponsiveVideoWrapper embedCode={embedCode} />
            )}
            <div className="image-text-content">
              <h2>{title}</h2>
              <ImageWithTextDescriptionStyled dangerouslySetInnerHTML={{ __html: description }} />
              {buttonText && (
                <ButtonLink
                  link={buttonUrl}
                  type={buttonType}
                  text={buttonText}
                  icon={icon}
                  theme={lightDarkTheme}
                />
              )}
            </div>
          </div>
        </ImageWithTextStyled>
      </ServerStylesConditionalWrapper>
    </WidgetIdWrapper>
  );
};

export default withWidgetSpacingWrapper(ImageWithTextComponent);
